import { PublicApiAuthScope } from "@redotech/crdb-enums/common/public-api-auth-scope";
import * as z from "zod";

type ApiScope = `${PublicApiAuthScope}`;
const apiScopeSchema: z.ZodType<ApiScope, ApiScope> =
  z.enum(PublicApiAuthScope);

export const apiScopesSchema = z.array(apiScopeSchema);

export const apiTokenNameSchema = z.string().trim().min(1).max(100);

export const apiTokenIdSchema = z.string().min(1).max(64);

/** A store token as listed: never the secret, only enough of it to recognize. */
export const StoreApiTokenSummarySchema = z.object({
  id: z.string(),
  name: z.string(),
  tokenPrefix: z.string(),
  tokenSuffix: z.string(),
  scopes: apiScopesSchema,
  createdAt: z.iso.datetime(),
  lastUsedAt: z.iso.datetime().nullable(),
  revokedAt: z.iso.datetime().nullable(),
});

export type StoreApiTokenSummary = z.infer<typeof StoreApiTokenSummarySchema>;
